import React from 'react';
import { Form } from 'react-bootstrap';
import { fieldMessage, hasError } from './blockUtils';

export const ACCURACY_ID = 'sa-confirms-submission-accuracy';
const ERROR_ID = `${ACCURACY_ID}-error`;

export function getErrors(answers) {
    if (answers?.confirmsSubmissionAccuracy === true) return [];
    return [{ id: ACCURACY_ID, label: 'Accuracy confirmation' }];
}

export function isComplete(answers) {
    return getErrors(answers).length === 0;
}

// The wizard calls this with the answers after any change; it returns the
// answers unticked when the box was ticked, and the same object otherwise.
export function untickAccuracyConfirmation(answers) {
    if (answers?.confirmsSubmissionAccuracy !== true) return answers;
    return { ...answers, confirmsSubmissionAccuracy: false };
}

// A nominated student has no application: `context.nominee` words the
// sentence and its refusal for their answers and their accept.
function AccuracyConfirmation({ answers, onChange, errorIds, context }) {
    const nominee = context?.nominee === true;
    const serverMessage = fieldMessage(context, ACCURACY_ID);
    const invalid = hasError(errorIds, ACCURACY_ID) || Boolean(serverMessage);
    return (
        <div>
            <p className="text-danger small mb-2" aria-live="polite">
                {context?.confirmationCleared &&
                    answers.confirmsSubmissionAccuracy !== true &&
                    'Your confirmation was cleared because an answer changed. Please confirm again.'}
            </p>
            <Form.Check
                type="checkbox"
                id={ACCURACY_ID}
                label={
                    <>
                        {nominee
                            ? 'I confirm these answers are accurate to the best of my knowledge.'
                            : 'I confirm the information in this application is accurate to the best of my knowledge.'}{' '}
                        <span className="text-danger" aria-hidden="true">
                            *
                        </span>
                    </>
                }
                checked={answers.confirmsSubmissionAccuracy === true}
                onChange={(e) =>
                    onChange('confirmsSubmissionAccuracy', e.target.checked)
                }
                required
                aria-required="true"
                isInvalid={invalid}
                aria-invalid={invalid}
                aria-describedby={invalid ? ERROR_ID : undefined}
            />
            {invalid && (
                <Form.Control.Feedback
                    type="invalid"
                    id={ERROR_ID}
                    role="alert"
                    className="d-block"
                >
                    {serverMessage ||
                        (nominee
                            ? 'Confirm that your answers are accurate before you accept.'
                            : 'Confirm that your application is accurate before submitting.')}
                </Form.Control.Feedback>
            )}
        </div>
    );
}

export default AccuracyConfirmation;
